import React, { useCallback, useRef, useState } from "react";
import {
  I2cBrand,
  I2cButton,
  I2cInput,
  I2cPasswordField,
} from "@webcomponents/i2cwebcomponents/dist/react";
import AsideSection from "../../../Components/AsideSection/AsideSection";
// @ts-expect-error
import logo from "../../../assets/images/i2c_logo.svg";
// @ts-expect-error
import banner from "../../../assets/images/login_art.svg";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthHeadDesc from "../../../Components/SharedComponent/AuthHeaderSection/AuthHeaderSection";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { passwordValidationSchema } from "./ValidationSchema";
import { useMutation } from "react-query";
import AuthService from "../../../Services/AuthServices";
import "../../../Utils/shared-styles/Authentication.scss";
import AlertMessage from "../../../Components/SharedComponent/Alert/Alert";
import DarkModeBtn from "../../../Components/DarkModeBtn/DarkModeBtn";
import "./ResetPassword.scss";
const ResetPassword = () => {
  // const [param, setParams] = useSearchParams();
  const { id: resetLinkId } = useParams();
  const form = useRef();
  const [recaptcha, setRecaptcha] = useState("");
  const navigate = useNavigate();
  const [passwordValidator, setPasswordValidator] = useState();
  // To stop the continous calling of verification of google recaptcha
  const onVerify = useCallback((token) => {
    setRecaptcha(token);
  }, []);

  // Reset password mutation
  const resetPassword = useMutation({
    mutationFn: async (values) => {
      return await AuthService.resetPassword({
        ...values,
        token: resetLinkId,
        recaptcha: recaptcha,
      });
    },
    onSuccess: (data) => {
      const email = `email=${data.data.email ?? ""}`;
      navigate(`/reset-success?${email}`);
    },
  });

  const resetPasswordError = resetPassword.error;

  // FormEventHandler<HTMLFormElement>
  const handleSubmitForm = (e) => {
    if (recaptcha) {
      resetPassword.mutate(e);
    } else {
    }
  };

  // Hook form initialization and methods
  const methods = useForm({
    resolver: zodResolver(passwordValidationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      password: "",
      password_confirmation: "",
    },
  });

  // Hook form methods destructuring
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  return (
    <React.Fragment>
      <div className="layout_aside">
        <div className="layout_aside-left">
          <AsideSection
            image={banner}
            heading={"Transforming Visions into Realities"}
            description={`Go beyond industry standards, setting new benchmarks for success. Join us on a journey of innovation, efficiency, and client satisfaction, where every project tells a unique story.`}
          />
        </div>
        <div className="layout_aside-right forStandAlone">
          <div className="right-container">
            <div className="login  auth__main-right">
              <div className="dark-mode-btn-wrapper">
                <DarkModeBtn />
              </div>
              <div className="auth__right-content">
                <div className="login__content-wrapper auth__content-wrapper">
                  <header id="header">
                    <I2cBrand
                      className="login__logo"
                      label="Client Implementation Portfolio"
                      logo={logo}
                      target=""
                    ></I2cBrand>
                  </header>
                  <AuthHeadDesc
                    title="Change Password"
                    description="For security Purposes, it is recommended that you change your password/passphrase regularly. Your password/passphrase will expire in ninty (90) days."
                  />
                  <div className="login__form">
                    <AlertMessage
                      open={resetPassword.isError}
                      message={resetPasswordError?.response?.message}
                    />
                    {resetPassword?.data?.data?.message && (
                      <AlertMessage
                        open={true}
                        variant="success"
                        closeAble
                        headerArt={"linear-tick-circle"}
                        message={resetPassword.data.data.message}
                      />
                    )}
                    <form
                      onSubmit={handleSubmit(handleSubmitForm)}
                      ref={form}
                      autoComplete="on"
                      className="resetPass"
                    >
                      <div className="login__form-group field-group">
                        <Controller
                          name="password"
                          control={methods.control}
                          render={({ field }) => (
                            <>
                              {/* <I2cInput
                              size="large"
                              label="Create Password"
                              type="password"
                              placeholder="Password@123"
                              name="password"
                              className={`auth__custom-input`}
                              required
                              invalid={errors.password ? true : false}
                              onI2cInput={(e) => {
                                field.onChange(e.target.value ?? "");
                                setPasswordValidator(e.target.value ?? "");
                              }}
                              onI2cBlur={field.onBlur}
                              togglePassword={true}
                            >
                              <I2cIcon
                                slot="hide-password-icon"
                                name={"linear-eye"}
                              />
                              <I2cIcon
                                slot="show-password-icon"
                                name={"linear-eye-slash"}
                              />
                               </I2cInput> */}

                              <I2cPasswordField
                                name="password"
                                className={`auth__custom-input`}
                                onI2cBlur={field.onBlur}
                                onI2cChange={(e) => {
                                  field.onChange(e.target.value ?? "");
                                  setPasswordValidator(e.target.value ?? "");
                                  methods.trigger();
                                }}
                                toggle-password
                                placeholder="Password@123"
                                label="Create Password"
                                // pattern="^(?=.*[0-9])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$"
                                required
                                strength-box
                                conditions={[
                                  {
                                    text: "Special character",
                                    srOnlyText: "1 Special Character",
                                    regexValue: ".*[^a-zA-Z0-9].*",
                                    status: false,
                                  },
                                  {
                                    text: "Minimum 13 characters",
                                    srOnlyText:
                                      "password length should be minimum 13 characters",
                                    regexValue: "^.{13,}$",
                                    status: false,
                                  },
                                  {
                                    text: "Number",
                                    srOnlyText: "1 Number",
                                    regexValue: ".*[0-9].*",
                                    status: false,
                                  },
                                  {
                                    text: "Capital Letter",
                                    srOnlyText: "! Capital ",
                                    regexValue: "[A-Z]",
                                    status: false,
                                  },
                                ]}
                              />
                            </>
                          )}
                        />
                        {/* <PasswordValidator
                          passwordValidator={passwordValidator}
                        /> */}
                        <ErrorMessage
                          show={errors.password ? true : false}
                          message={errors.password?.message ?? "Invalid input"}
                        />
                      </div>

                      <div className="login__form-group field-group">
                        <Controller
                          name="password_confirmation"
                          control={methods.control}
                          render={({ field }) => (
                            <I2cInput
                              size="large"
                              type="password"
                              label="Confirm Password"
                              placeholder="Password@123"
                              name="password_confirmation"
                              className={`auth__custom-input`}
                              required
                              invalid={
                                errors.password_confirmation ? true : false
                              }
                              togglePassword={true /* passIcon */}
                              onI2cInput={(e) => {
                                field.onChange(e);
                                methods.trigger();
                              }}
                              onI2cBlur={field.onBlur}
                            ></I2cInput>
                          )}
                        />
                        <ErrorMessage
                          show={errors.password_confirmation ? true : false}
                          message={
                            errors.password_confirmation?.message ??
                            "Invalid input"
                          }
                        />
                      </div>
                      <GoogleReCaptcha
                        onVerify={onVerify}
                        refreshReCaptcha={false}
                      />

                      <div className="confirmed-action-acion-button-reset-success">
                        <I2cButton
                          variant="secondary gray"
                          size={"medium"}
                          className="login__sign-btn fw-500"
                          style={{ width: "48%" }}
                          onClick={() => navigate("/login")}
                        >
                          <Link
                            to={"/login"}
                            style={{
                              textDecoration: "none",
                              fontWeight: "500",
                            }}
                          >
                            Back
                          </Link>
                        </I2cButton>
                        <I2cButton
                          destructive={false}
                          className="login__sign-btn"
                          size={"medium"}
                          style={{ width: "48%" }}
                          disabled={!methods.formState.isValid}
                          onClick={() => handleSubmitForm(methods.getValues())}
                        >
                          Submit
                        </I2cButton>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="login__footer_mobile">
            <p className="login-aside__footer-text">
              i2c Inc. &copy; {new Date().getFullYear()} All Rights Reserved.
            </p>
          </footer>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
